/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { Component, OnInit, Input, ViewContainerRef, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ItineraryService } from '../../itinerary.service';
import { DatePipe } from '@angular/common';
import { isValidOwener } from '../../../utils/Functions';
import { CookieService } from 'ngx-cookie';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { TransportsService } from './transports.service';
@Component({
  selector: 'usb-modal-transports',
  templateUrl: './modal-transports.component.html',
  styleUrls: ['./modal-transports.component.scss'],
  providers: [DatePipe]
})

export class ModalTransportsComponent implements OnInit, OnChanges {

  @Input() productQty: number;
  @Input() product: any;
  @Input() service: any;
  @Input() result: any;
  @Input() form: any;
  @Input() payload?: any;
  @Input() payloadUpdate?: any;
  @Input() itineraryItem?: any;
  @Input() origin?: any;
  @Input() arrayResults?: any;
  @Input() _item?: any;
  @Input() view_info: any;
  @Input() fliyingInfo: any;
  @Input() formTransport: any;
  @Input() clientSetting: any;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() tabActive: any;
  @Input() paymentAgencyActive: any;
  @Input() vehicles: any[] = [];
  @Input() quote = true;
  @Input() action = '';
  @Input() from = '';
  @Output() refModal = new EventEmitter<any>();


  disableButton = false;
  max: number;
  rate = 4;
  ratereview = 4.5;
  isReadonly: boolean;
  x = 5;
  y = 2;
  select: any[] = [];
  totalQty = 0;
  single: any[];
  view: any[] = [200, 150];
  categories = [];
  price: any;
  // options
  rates = [];
  ticketsPrice: any;
  days = [];
  daysArray = [];
  ticketResult: any;
  ticket: any;
  _days: any;
  mealResult: any;
  _rated: any;
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = '.';
  showYAxisLabel = true;
  item: any;
  yAxisLabel = '%';
  selected: any;
  _resultsQuery: any;
  currencySelected: string;
  colorScheme = {
    domain: ['#00a680', '#00a680', '#00a680', '#00a680', '#00a680']
  };
  selectedOneVehicleDoubleWay = false;

  public options = {
    position: ['top', 'right'],
    timeOut: 460,
    lastOnBottom: true,
    showProgressBar: false,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 60
  };


  constructor(
    public vcr: ViewContainerRef,
    private _itineraryService: ItineraryService,
    private _userService: UserService,
    private _cookieService: CookieService,
    private transportService: TransportsService) {}
  ngOnChanges(changes: SimpleChanges): void {

    if(changes['form']) {
      this.form = changes['form'].currentValue;
    }
    if(changes['payload']) {
      this.payload = changes['payload'].currentValue;
    }
    if(changes['formTransport']) {
      this.formTransport = changes['formTransport'].currentValue;
    }
  }


  ngOnInit() {

  }

  /** Safe localStorage JSON reader used by the debug block. */
  private _tryReadLs(key: string): any {
    const raw = localStorage.getItem(key);
    if (raw === null) {
return null;
}
    try {
 return JSON.parse(raw);
} catch {
 return raw;
}
  }

  /**
   * Método para construir el payload de actualización para un solo trayecto
   *
   * Genera un objeto con la estructura necesaria para actualizar productos relacionados a un solo trayecto
   * en el sistema, tomando datos del objeto `item` y `payload` recibidos.
   *
   * @param item -> objeto que contiene la información del producto y traslado
   * @param payload -> objeto con datos adicionales para construir el payload
   * @returns objeto con la estructura del payload para actualización
   */

  _payloadUpdate(item: any, payload: any): Object {

    return {
      products: [{
        bookingCode: item.bookParam,
        providerId: item.providerId,
        nameAdapter: null, // pedir el nameAdapter
        categoryId: item.payload[0].categoriesId[0],
        productId: item.idProduct,
        productName: item.vehicle.name,
        origin: item.payload[0].transfers.pickupLocation.origin ,
        destination: item.payload[0].transfers.dropoffLocation.destination,
        priceFrom: 0,
        priceTo: 10000.00,
        arrivalDate: item.payload[0].arrivalDate,
        departureDate: item.payload[0].departureDate,
        qtyProduct: 1,
        qtyPax: 0,
        others: {
          transfers: {
            paxList: item.payload[0].transfers.paxList
          }
        }
      }]
    };
  }

  /**
   * Método para construir el payload de actualización para trayecto ida y vuelta (two way)
   *
   * Similar a `_payloadUpdate`, pero se utiliza para actualizar productos que corresponden a traslados
   * de ida y vuelta, manteniendo la estructura requerida.
   *
   * @param item -> objeto que contiene la información del producto y traslado
   * @param payload -> objeto con datos adicionales para construir el payload
   * @returns objeto con la estructura del payload para actualización de dos trayectos
   */

  _payloadUpdateTwoWay(item: any, payload: any): Object {

    return {
      products: [{
        bookingCode: item.bookParam,
        providerId: item.providerId,
        nameAdapter: null, // pedir el nameAdapter
        categoryId: item.payload[0].categoriesId[0],
        productId: item.idProduct,
        productName: item.vehicle.name,
        origin: item.payload[0].transfers.pickupLocation.origin,
        destination: item.payload[0].transfers.dropoffLocation.destination,
        priceFrom: 0,
        priceTo: 10000.00,
        arrivalDate: item.payload[0].arrivalDate,
        departureDate: item.payload[0].departureDate,
        qtyProduct: 1,
        qtyPax: 0,
        others: {
          transfers: {
            paxList: item.payload[0].transfers.paxList
          }
        }
      }]
    };
  }


  /**
   * Método para agregar un ítem al itinerario según el tipo de trayecto (firstWay, noFirstWay, totalWay)
   *
   * Valida que el owner esté definido antes de agregar. Configura y asigna múltiples propiedades del ítem
   * según el tipo de trayecto, sincroniza payloads, calcula precios y atributos relacionados, y luego envía
   * el ítem al servicio de itinerario para su almacenamiento.
   *
   * @param item -> objeto que representa el ítem o producto a agregar al itinerario
   * @param result -> objeto con datos resultantes o adicionales para el ítem
   * @param typeWay -> cadena que indica el tipo de trayecto ('firstWay', 'noFirstWay', 'totalWay')
   */

  /**
   * Resolve the effective pickup datetime string for the current vehicle.
   *
   * The modal historically relied on `this.form.firstArrivalDate`, which the
   * parent (search-box) leaves as `null` when the user is doing a
   * ride-hailing search ("viaje ahora"). In that case the backend still
   * returns the actual service time on `item.timing.entry.entryDepartureDatetime`
   * (e.g. `"2026-06-15 17:17"`), so we fall back to that before giving up.
   *
   * Returns the raw string (`"YYYY-MM-DD HH:mm"` or ISO with `T`) so callers
   * can pick the slice they need. Returns `null` if nothing usable is found.
   */
  private resolvePickupDateTime(item: any): string | null {
    const fromForm = this.form?.firstArrivalDate;
    if (fromForm) {
return String(fromForm);
}
    const fromItem = item?.timing?.entry?.entryDepartureDatetime;
    if (fromItem) {
return String(fromItem);
}
    return null;
  }

  /**
   * Extract the date portion (YYYY-MM-DD) from a datetime string, accepting
   * both `"YYYY-MM-DD HH:mm"` and ISO `"YYYY-MM-DDT..."` formats. Returns
   * `null` for any falsy / malformed input.
   */
  private toDateOnly(value: string | null | undefined): string | null {
    if (!value) {
return null;
}
    const idxSpace = value.indexOf(' ');
    const idxT = value.indexOf('T');
    let cut: number;
    if (idxSpace === -1 && idxT === -1) {
      cut = -1;
    } else if (idxSpace === -1) {
      cut = idxT;
    } else if (idxT === -1) {
      cut = idxSpace;
    } else {
      cut = Math.min(idxSpace, idxT);
    }
    const date = cut === -1 ? value : value.substring(0, cut);
    return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : null;
  }

private randomSum = 0;
  addToItinerary(item: any, result: any, typeWay: string) {

    // validar si owner esta lleno
    if (!isValidOwener(this._cookieService.get('clientActive'))) {

        return;
    }

    item.categoryName = this.origin;
    let payload = JSON.parse(localStorage.getItem('payload'));
    this.formTransport = JSON.parse(localStorage.getItem('form'));
    const transport_assignment = JSON.parse(localStorage.getItem('transport_assignment'));

    if (this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component) {
        if (this.arrayResults[0].component === 'suggestion_itinerary') {
            payload = [this.payload];
        }
    }

    if ((transport_assignment && transport_assignment.selectedVehicles.length > 0) ||
        (this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component && this.arrayResults[0].component === 'suggestion_itinerary')) {
        payload[0].transfers.paxList = {
            adults: transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults : payload[0].transfers.paxList?.adults,
            children: transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges : payload[0].transfers.paxList?.children
        };
        this.form.firstqtyAdults = transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults : payload[0].transfers.paxList?.adults;
        this.form.firstqtyChilds = transport_assignment ? transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges : payload[0].transfers.paxList?.children;
    } else {

        return;
    }

    const pickupDateTime = this.resolvePickupDateTime(item);
    const arrivalDate = this.toDateOnly(pickupDateTime);

    let returnPayload: any = null;
    let returnForm: any = null;

    if (!payload[0].transfers.oneWay && localStorage.getItem('returnTransferPayload') && localStorage.getItem('returnTransferForm')) {
        returnPayload = JSON.parse(localStorage.getItem('returnTransferPayload'));
        returnForm = JSON.parse(localStorage.getItem('returnTransferForm'));
        returnPayload[0].transfers.paxList = {
            adults: transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults,
            children: transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges
        };
        returnForm.firstqtyAdults = transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.adults;
        returnForm.firstqtyChilds = transport_assignment.selectedVehicles[transport_assignment.selectedVehicles.length - 1]?.childrenAges;
    }

    item.id = item.id;
    item.providerId = item.providerId;
    item.idProduct = item.productId;
    item.nameAdapter = result.nameAdapter;

    // ✅ CLONAR EL ITEM PARA NOFIRSTWAY ANTES DE MODIFICARLO
    let itemToAdd = item;
    if (typeWay === 'noFirstWay') {
        itemToAdd = JSON.parse(JSON.stringify(item));
    }

    // ✅ GENERAR PRODUCTKEY ÚNICO

    const uniqueId = `${item.id}_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    itemToAdd.productKey = (this.getRandomUniqueId?.() + this.randomSum) || uniqueId;
    this.randomSum++;

    switch (typeWay) {

        case 'firstWay':

            itemToAdd.vehicleCode = item.vehicle ? item.vehicle.code : null;
            itemToAdd.maxPax = item.vehicle ? item.vehicle.maxPax : null;
            itemToAdd.payload = payload ?? null;
            itemToAdd.origin = this.form?.firstOrigin ?? null;
            itemToAdd.destination = this._itineraryService.getDestinationInfo?.(this.form, item) ?? null;
            itemToAdd.arrivalDate = arrivalDate;
            itemToAdd.departureDate = arrivalDate;
            itemToAdd.formTransport = this.formTransport ?? null;
            itemToAdd.payloadUpdate = this._payloadUpdate?.(item, payload) ?? null;
            itemToAdd.payloadSync = this.payloadSync(item, payload, typeWay);
            itemToAdd.tax = item.tax ?? null;
            itemToAdd.profility = { ...(item.profilityEntry ?? {}) };
            itemToAdd.profility.netPriceBooking = item.profilityEntry.netPriceBooking;
            itemToAdd.profility.netPriceAgent = item.profilityEntry.netPriceBooking;
            itemToAdd.profilityEntry.netPriceBooking = item.profilityEntry.netPriceBooking;
            itemToAdd.profilityEntry.netPriceAgent = item.profilityEntry.netPriceAgent ;

            // CALCULAR TOTAL DE ADICIONALES
            let totalAddonsFirstWay = 0;
            (item.amenitiesIncluded || []).forEach((addon: any) => {
                totalAddonsFirstWay += addon.totalPrice || addon.priceProf || addon.price || 0;
            });
            (item.addonsIncluded || []).forEach((addon: any) => {
                totalAddonsFirstWay += addon.totalPriceProf || addon.totalAmount || addon.price || 0;
            });

            if (totalAddonsFirstWay > 0) {
                itemToAdd.profility.netPrice = (itemToAdd.profility.netPrice || 0) + totalAddonsFirstWay;
                itemToAdd.profility.netPriceCategory = (itemToAdd.profility.netPriceCategory || 0) + totalAddonsFirstWay;
                itemToAdd.profility.netPriceProvider = (itemToAdd.profility.netPriceProvider || 0) + totalAddonsFirstWay;
                itemToAdd.profility.netPriceBooking = (itemToAdd.profility.netPriceBooking || 0) + totalAddonsFirstWay;
                itemToAdd.profility.netPriceAgent = (itemToAdd.profility.netPriceBooking || 0) + totalAddonsFirstWay;
                itemToAdd.profility.blickoins = (itemToAdd.profility.blickoins || 0) + (totalAddonsFirstWay * 0.2);
                itemToAdd.profility.creditBlickoins = (itemToAdd.profility.creditBlickoins || 0) + (totalAddonsFirstWay * 0.02);

                itemToAdd.profilityEntry.netPrice = (itemToAdd.profilityEntry.netPrice || 0) + totalAddonsFirstWay;
                itemToAdd.profilityEntry.netPriceCategory = (itemToAdd.profilityEntry.netPriceCategory || 0) + totalAddonsFirstWay;
                itemToAdd.profilityEntry.netPriceProvider = (itemToAdd.profilityEntry.netPriceProvider || 0) + totalAddonsFirstWay;
                itemToAdd.profilityEntry.netPriceBooking = (itemToAdd.profilityEntry.netPriceBooking || 0) + totalAddonsFirstWay;
                itemToAdd.profilityEntry.netPriceAgent = (itemToAdd.profilityEntry.netPriceBooking || 0) + totalAddonsFirstWay;
                itemToAdd.profilityEntry.blickoins = (itemToAdd.profilityEntry.blickoins || 0) + (totalAddonsFirstWay * 0.2);
                itemToAdd.profilityEntry.creditBlickoins = (itemToAdd.profilityEntry.creditBlickoins || 0) + (totalAddonsFirstWay * 0.02);
            }

            itemToAdd.priceUnitary = itemToAdd.profilityEntry?.netPrice ?? null;
            itemToAdd.netPriceFreeTax = itemToAdd.profilityEntry?.netPrice ?? null;
            itemToAdd.totalPriceFreeTax = itemToAdd.profilityEntry?.netPriceBooking ?? null;
            itemToAdd.totalPriceProf = itemToAdd.profilityEntry?.netPriceBooking ?? null;
            itemToAdd.netPriceProf = itemToAdd.profilityEntry?.netPriceBooking ?? null;
            itemToAdd.netPriceBookingWithIncluded = item.netPriceBookingWithIncluded ? item.netPriceBookingWithIncluded : null;
            itemToAdd.amount = itemToAdd.profilityEntry?.netPriceBooking ?? null;
            itemToAdd.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
            itemToAdd.totalPrice = item.pricing?.totalPrice ?? null;
            itemToAdd.blickoins = itemToAdd.profilityEntry?.blickoins ?? null;
            itemToAdd.creditBlickoins = itemToAdd.profilityEntry?.creditBlickoins ?? null;
            itemToAdd.cancellationPolicies = item?.timing?.entry?.entryCancellationPolicies || [];
            itemToAdd.arrivalDate = this.formTransport?.firstArrivalDate?.split('T')[0] ?? null;
            itemToAdd.departureDate = this.formTransport?.firstArrivalDate?.split('T')[0] ?? null;
            itemToAdd.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
                ? this.adjustDate(item?.timing?.entry?.entryCancellationPolicies[0]?.from, -1) ?? payload?.pickupDate
                : null;
            itemToAdd.firstWay = 1;
            itemToAdd.wayType = 'outbound';

            break;

        case 'noFirstWay':
            if (!returnPayload || !returnForm) {
                console.error('❌ No hay datos de retorno para noFirstWay');
                return;
            }
            itemToAdd.payloadSync = undefined;
            itemToAdd.vehicleCode = item.vehicle?.code ?? null;
            itemToAdd.maxPax = item.vehicle?.maxPax ?? null;
            itemToAdd.payload = returnPayload ?? null;
            itemToAdd.origin = returnForm[0]?.firstOrigin ?? null;
            itemToAdd.destination = this._itineraryService.getDestinationInfo?.(returnForm[0], item) ?? null;
            itemToAdd.arrivalDate = returnForm[0]?.firstArrivalDate?.split('T')[0] ?? null;
            itemToAdd.departureDate = returnForm[0]?.firstArrivalDate?.split('T')[0] ?? null;
            itemToAdd.formTransport = returnForm[0] ?? null;
            itemToAdd.payloadUpdate = this._payloadUpdateTwoWay?.(item, payload) ?? null;
            itemToAdd.payloadSync = this.payloadSync(item, payload, typeWay);
            itemToAdd.tax = item.tax ?? null;
            itemToAdd.profility = { ...(item.profilityReturn ?? {}) };
            itemToAdd.profility.netPriceBooking =  item.profilityReturn.netPriceBooking ;
            itemToAdd.profility.netPriceAgent = item.profilityReturn.netPriceBooking;
            itemToAdd.profilityReturn.netPriceBooking =  item.profilityReturn.netPriceBooking;
            itemToAdd.profilityReturn.netPriceAgent = item.profilityReturn.netPriceBooking;

            let totalAddonsNoFirstWay = 0;
            (item.amenitiesIncluded || []).forEach((addon: any) => {
                totalAddonsNoFirstWay += addon.totalPrice || addon.priceProf || addon.price || 0;
            });
            (item.addonsIncluded || []).forEach((addon: any) => {
                totalAddonsNoFirstWay += addon.totalPriceProf || addon.totalAmount || addon.price || 0;
            });

            if (totalAddonsNoFirstWay > 0) {
                itemToAdd.profility.netPrice = (itemToAdd.profility.netPrice || 0) + totalAddonsNoFirstWay;
                itemToAdd.profility.netPriceCategory = (itemToAdd.profility.netPriceCategory || 0) + totalAddonsNoFirstWay;
                itemToAdd.profility.netPriceProvider = (itemToAdd.profility.netPriceProvider || 0) + totalAddonsNoFirstWay;
                itemToAdd.profility.netPriceBooking = (itemToAdd.profility.netPriceBooking || 0) + totalAddonsNoFirstWay;
                itemToAdd.profility.netPriceAgent = (itemToAdd.profility.netPriceBooking || 0) + totalAddonsNoFirstWay;
                itemToAdd.profility.blickoins = (itemToAdd.profility.blickoins || 0) + (totalAddonsNoFirstWay * 0.2);
                itemToAdd.profility.creditBlickoins = (itemToAdd.profility.creditBlickoins || 0) + (totalAddonsNoFirstWay * 0.02);

                itemToAdd.profilityReturn.netPrice = (itemToAdd.profilityReturn.netPrice || 0) + totalAddonsNoFirstWay;
                itemToAdd.profilityReturn.netPriceCategory = (itemToAdd.profilityReturn.netPriceCategory || 0) + totalAddonsNoFirstWay;
                itemToAdd.profilityReturn.netPriceProvider = (itemToAdd.profilityReturn.netPriceProvider || 0) + totalAddonsNoFirstWay;
                itemToAdd.profilityReturn.netPriceBooking = (itemToAdd.profilityReturn.netPriceBooking || 0) + totalAddonsNoFirstWay;
                itemToAdd.profilityReturn.netPriceAgent = (itemToAdd.profilityReturn.netPriceBooking || 0) + totalAddonsNoFirstWay;
                itemToAdd.profilityReturn.blickoins = (itemToAdd.profilityReturn.blickoins || 0) + (totalAddonsNoFirstWay * 0.2);
                itemToAdd.profilityReturn.creditBlickoins = (itemToAdd.profilityReturn.creditBlickoins || 0) + (totalAddonsNoFirstWay * 0.02);
            }

            itemToAdd.priceUnitary = itemToAdd.profilityReturn?.netPrice ?? null;
            itemToAdd.netPriceFreeTax = itemToAdd.profilityReturn?.netPrice ?? null;
            itemToAdd.totalPriceFreeTax = itemToAdd.profilityReturn?.netPriceBooking ?? null;
            itemToAdd.totalPriceProf = itemToAdd.profilityReturn?.netPriceBooking ?? null;
            itemToAdd.netPriceProf = itemToAdd.profilityReturn?.netPriceBooking ?? null;
            itemToAdd.netPriceBookingWithIncluded = item.netPriceBookingWithIncluded ? item.netPriceBookingWithIncluded : null;
            itemToAdd.amount = itemToAdd.profilityReturn?.netPriceBooking ?? null;
            itemToAdd.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
            itemToAdd.totalPrice = item.pricing?.totalPrice ?? null;
            itemToAdd.blickoins = itemToAdd.profilityReturn?.blickoins ?? null;
            itemToAdd.creditBlickoins = itemToAdd.profilityReturn?.creditBlickoins ?? null;
            itemToAdd.cancellationPolicies = item?.timing?.return?.returnCancellationPolicies || [];
            itemToAdd.expiration_date = item?.timing?.return?.returnCancellationPolicies?.length > 0
                ? this.adjustDate(item?.timing?.return?.returnCancellationPolicies[0]?.from, -1) ?? returnPayload?.pickupDate
                : null;
            itemToAdd.firstWay = 2;
            itemToAdd.wayType = 'return';
            break;

        case 'totalWay':
                if (!payload[0].transfers.oneWay && !this.selectedOneVehicleDoubleWay) {
      const val = this._userService.numberNoCloneOneWay;

      item.wayNoCloneVehicleDoubleWay = val === 0 ? 1 : val === 1 ? 2 : 1;
      this._userService.numberNoCloneOneWay = item.wayNoCloneVehicleDoubleWay;
      item.vehicleCode = item.vehicle?.code ?? null;
      item.maxPax = item.vehicle?.maxPax ?? null;

      if (this._userService.numberNoCloneOneWay === 1) {
        item.payload = payload ?? null;
        item.origin = this.form?.firstOrigin ?? null;
        item.destination = this._itineraryService?.getDestinationInfo?.(this.form, item) ?? null;
        item.arrivalDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
        item.departureDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
        item.formTransport = this.formTransport ?? null;
        item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
          ? item?.timing?.entry?.entryCancellationPolicies[0]?.from ?? payload?.pickupDate
          : null;
        item.noCloneFirstWay = 1;
        this._userService.numberNoCloneOneWay = 2;
      } else if (this._userService.numberNoCloneOneWay === 2) {
        item.payload = returnPayload ?? null;
        item.origin = returnForm[0].firstOrigin ?? null;
        item.destination = this._itineraryService.getDestinationInfo?.(returnForm[0], item) ?? null;
        item.arrivalDate = returnForm[0]?.firstArrivalDate.split('T')[0] ?? null;
        item.departureDate = returnForm[0]?.firstArrivalDate.split('T')[0] ?? null;
        item.formTransport = returnForm[0] ?? null;
        item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
          ? this.adjustDate(item?.timing?.entry?.entryCancellationPolicies[0]?.from, -1) ?? returnPayload?.pickupDate
          : null;
        item.noCloneFirstWay = 2;
        this._userService.numberNoCloneOneWay = 0;
      }

      item.productKey = this.getRandomUniqueId?.() ?? null;
      item.payloadUpdate = this._payloadUpdate?.(item, payload) ?? null;
      item.payloadSync = this.payloadSync(item, payload, typeWay);
      item.tax = item.tax ?? null;
      item.netPriceProf = item.netPriceBookingWithIncluded ?? null;
      item.amount = item.netPriceProf ?? null;
      item.totalPrice = item.pricing?.totalPrice ?? null;
      item.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
      item.blickoins = item.profility?.blickoins ?? null;
      item.creditBlickoins = item.profility?.creditBlickoins ?? null;
      item.cancellationPolicies = item?.timing?.entry?.entryCancellationPolicies || [];
      item.totalWay = 1;
    }

    if (payload[0].transfers.oneWay) {
      item.vehicleCode = item.vehicle?.code ?? null;
      item.maxPax = item.vehicle?.maxPax ?? null;
      item.payload = payload ?? null;
      item.origin = this.form?.firstOrigin ?? null;
      item.destination = this._itineraryService?.getDestinationInfo?.(this.form, item) ?? null;
      item.arrivalDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
      item.departureDate = item.timing.entry['entryDepartureDatetime'].split('T')[0] ?? null;
      item.formTransport = this.formTransport ?? null;
      item.productKey = this.getRandomUniqueId?.() ?? null;
      item.payloadUpdate = this._payloadUpdate?.(item, payload) ?? null;
      item.payloadSync = this.payloadSync(item, payload, typeWay);
      item.tax = item.tax ?? null;

      // ✅ CALCULAR TOTAL DE ADICIONALES
      let totalAddonsTotalWay = 0;
      (item.amenitiesIncluded || []).forEach((addon: any) => {
        totalAddonsTotalWay += addon.totalPrice || addon.priceProf || addon.price || 0;
      });
      (item.addonsIncluded || []).forEach((addon: any) => {
        totalAddonsTotalWay += addon.totalPriceProf || addon.totalAmount || addon.price || 0;
      });

      // ✅ SUMAR ADICIONALES A PROFILITY
      item.profility.netPrice = (item.profility.netPrice || 0) + totalAddonsTotalWay;
      item.profility.netPriceCategory = (item.profility.netPriceCategory || 0) + totalAddonsTotalWay;
      item.profility.netPriceProvider = (item.profility.netPriceProvider || 0) + totalAddonsTotalWay;
      item.profility.netPriceBooking = (item.profility.netPriceBooking || 0) + totalAddonsTotalWay;
      item.profility.netPriceAgent = (item.profility.netPriceBooking || 0) + totalAddonsTotalWay;
      item.profility.blickoins = (item.profility.blickoins || 0) + (totalAddonsTotalWay * 0.2);
      item.profility.creditBlickoins = (item.profility.creditBlickoins || 0) + (totalAddonsTotalWay * 0.02);

      item.profilityEntry.netPrice = (item.profilityEntry.netPrice || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceCategory = (item.profilityEntry.netPriceCategory || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceProvider = (item.profilityEntry.netPriceProvider || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceBooking = (item.profilityEntry.netPriceBooking || 0) + totalAddonsTotalWay;
      item.profilityEntry.netPriceAgent = (item.profilityEntry.netPriceBooking || 0) + totalAddonsTotalWay;
      item.profilityEntry.blickoins = (item.profilityEntry.blickoins || 0) + (totalAddonsTotalWay * 0.2);
      item.profilityEntry.creditBlickoins = (item.profilityEntry.creditBlickoins || 0) + (totalAddonsTotalWay * 0.02);

      item.netPriceProf = item.netPriceBookingWithIncluded ?? null;
      item.netPriceBookingWithIncluded = item.netPriceBookingWithIncluded ?? null;
      item.amount = item.netPriceProf ?? null;
      item.totalPrice = item.pricing?.totalPrice ?? null;
      item.priceWithoutTax = item.pricing?.priceWithoutTax ?? null;
      item.blickoins = item.profility?.blickoins ?? null;
      item.creditBlickoins = item.profility?.creditBlickoins ?? null;
      item.cancellationPolicies = item?.timing?.entry?.entryCancellationPolicies || [];
      item.expiration_date = item?.timing?.entry?.entryCancellationPolicies?.length > 0
        ? this.adjustDate(item?.timing?.entry?.entryCancellationPolicies[0]?.from, -1) ?? payload?.pickupDate
        : null;
      item.totalWay = 1;
            break;
    }
    }

    // ✅ Propiedades comunes para todos los casos
    itemToAdd.searchId = result?.searchId ?? null;
    itemToAdd.updateDate = new Date();
    itemToAdd.from = this.from;
    itemToAdd.providerName = item?.providerName ?? null;
    itemToAdd.title = item?.vehicle?.name ?? null;
    itemToAdd.serviceResponse = null;
    itemToAdd.transferId = result?.transferId ?? null;
    itemToAdd.cancellation_policy = itemToAdd?.cancellationPolicies ?? null;
    itemToAdd.expirationDate = result?.expirationDate ?? null;
    itemToAdd.bookParam = itemToAdd?.bookingCode ?? null;
    itemToAdd.bookingCode = itemToAdd?.bookingCode ?? null;
    itemToAdd.currency = item?.pricing?.currency ?? null;
    this.currencySelected = itemToAdd?.currency ?? null;
    this._itineraryService.sendMessageSubscriptorLoading(true);


    if(!itemToAdd) {
      alert('error en item');
      return;
    }

    // ✅ Usar el item clonado para agregar al itinerario

    this._itineraryService.add(itemToAdd).subscribe(
        (response: any) => {
            if (typeof response === 'string') {
            } else {
                this._itineraryService.currencySuccessEmit.next(itemToAdd.currency);
            }
            this._itineraryService.evaluateDateItineraryRange(this._itineraryService.itinerary['items']);
        },
        error => {
            this._itineraryService.sendMessageSubscriptorLoading(false);
        }
    );
}


  adjustDate(date: string | Date, days: number): string {
  if (!date) {
return '';
}

  // Convertir Date a string si es necesario
  let dateStr: string;
  if (typeof date === 'string') {
    dateStr = date;
  } else {
    // Asumiendo que es un objeto Date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    dateStr = `${year}-${month}-${day}`;
  }

  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

  /**
   * Método para sincronizar y construir el payload de un ítem de transporte según el tipo de trayecto
   *
   * Este método recibe un ítem, el payload original y el tipo de trayecto, y devuelve un objeto
   * con la estructura necesaria para sincronizar la información del traslado, incluyendo fechas,
   * información del vehículo, y lista de pasajeros.
   *
   * @param item -> objeto que contiene los datos del producto o traslado
   * @param payload -> arreglo con el payload original de la solicitud
   * @param typeWay -> string que indica el tipo de trayecto ('firstWay', 'noFirstWay', 'totalWay')
   * @returns objeto con los datos sincronizados para el traslado
   */

  payloadSync(item: any, payload: any, typeWay: string): any{

    return  {
      providerId: item.providerId,
      productId: item.productId,
      categoriesId: [8],
      pickupDate: item.timing?.entry?.entryDepartureDatetime,
      dropoffDate: item.timing?.return?.returnDepartureDatetime ? item.timing?.return?.returnDepartureDatetime : item.timing?.entry?.entryDepartureDatetime,
      market: payload[0].market, // Anteriormente el valor era de 2
      agencyId: this._userService._agencyID,
      id: item.id,
      transfers: {
        oneWay: typeWay !== 'totalWay' ? false : true,
        vehicleId: item.productId,
        vehicleCode: item.vehicle.code,
        bookingCode: item.bookingCode,
        paxList: payload[0].transfers.paxList
      }
    };
  }

  /**
   * Método para continuar con la selección del vehículo
   *
   * Este método maneja la lógica principal al continuar con la selección de un vehículo en un traslado.
   * Dependiendo de si el traslado es "oneWay" o no, agrega uno o dos tramos al itinerario y actualiza
   * la información del mismo, emitiendo eventos para el cierre del modal.
   *
   * @vehicle -> objeto con la información del vehículo seleccionado
   */

 async continue(vehicle: any): Promise<void> {

    this.transportService.assignVehicle(vehicle);
    let payload = JSON.parse(localStorage.getItem('payload'));
    if(this.arrayResults && this.arrayResults.length > 0 && this.arrayResults[0].component) {

      if(this.arrayResults[0].component === 'suggestion_itinerary') {
        payload = [this.payload];
      }
    }
    if(payload[0].transfers.oneWay || !this.selectedOneVehicleDoubleWay) {
      this._itineraryService.itinerary.clientId = this.clientSetting?.id;
      this.addToItinerary(vehicle, this.service, 'totalWay');
      this._emitRefModal('add');
      this._itineraryService.itinerary.currency = this.currencySelected;
      this._itineraryService.updateItinerary(this._itineraryService.itinerary);

      if(!this.selectedOneVehicleDoubleWay) {
        this._itineraryService.emitNoCloneVehicleDoubleWay();
      }

    } else {
      // this.addToItinerary(vehicle, this.service, 'firstWay');

      // this._itineraryService.updateItinerary(this._itineraryService.itinerary);


      try {
            // ✅ Primer viaje
            await this.addToItineraryAsync(vehicle, this.service, 'firstWay');

            // ✅ Segundo viaje
            await this.addToItineraryAsync(vehicle, this.service, 'noFirstWay');

            // ✅ Actualizar itinerario una sola vez con ambos viajes
            this._emitRefModal('add');
            this._itineraryService.itinerary.currency = this.currencySelected;
            this._itineraryService.itinerary.clientId = this.clientSetting?.id;
            this._itineraryService.updateItinerary(this._itineraryService.itinerary);

        } catch (error) {
            console.error('Error al agregar vehículos:', error);
            // Manejar error
        }

    }

  }

  private addToItineraryAsync(vehicle: any, service: any, type: string): Promise<void> {
    return new Promise((resolve) => {
        // ✅ Guardar el vehículo en el servicio
        // const serviceType = this.transportService.getServiceType(service);
        // const vehicleData = this.transportService.getVehicleData(vehicle);

        // ✅ Agregar al itinerario
        this.addToItinerary(vehicle, service, type);

        // ✅ Pequeño delay para asegurar que se procesó
        setTimeout(() => {
            resolve();
        }, 300);
    });
}

  canSelectVehicle(vehicle: any): boolean {
    return this.transportService.canAssignVehicle(vehicle);
  }

  getAssignmentStatus(): void {
  const current = this.transportService.getRemainingPassengers();
}

  /**
   * Método para seleccionar una única unidad para ida y vuelta
   *
   * Almacena si se seleccionó una sola unidad para el viaje de ida y vuelta.
   *
   * @event -> valor booleano que indica si se seleccionó un solo vehículo para ambos tramos
   */

  selectOneVehicleDoubleWay(event: boolean): void {
    this.selectedOneVehicleDoubleWay = event;
  }

  /**
   * Método para generar un ID único aleatorio
   *
   * Genera un identificador numérico único basado en un número aleatorio y la marca de tiempo actual.
   *
   * @returns número único aleatorio
   */

  getRandomUniqueId(){
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

  /**
   * Método para emitir el cierre del modal
   *
   * Emite un evento con valor `'pers'` a través de `refModal` para indicar que el modal debe cerrarse o actualizarse.
   */

  _emitRefModal(event: string) {
    this.refModal.emit(event);
  }

    /**
     * Extrae el nombre del transporte según el tipo y el formulario recibido
     *
     * @param form -> objeto con datos del transporte
     * @param type -> cadena que indica si es 'origin' o 'destination'
     * @returns string -> nombre del transporte formateado según tipo y datos
     */
  extractNameTransport(form: any, type: string): string {

    if(form) {
      switch(type) {
        case 'origin':
          switch(this.payload.transfers.pickupLocation.type) {
            case 'hotel':
              return form.name;
            case 'airport':
              return `${form.name} (${form.iata})`;
            case 'destination':
              return form.city_name;
          }
        case 'destination':
          switch(this.payload.transfers.dropoffLocation.type) {
            case 'hotel':
              return form.name;
            case 'airport':
              return `${form.name} (${form.iata})`;
            case 'destination':
              return form.city_name;
          }
      }
    }

  }

      getPayloadOneWay(): boolean {
        // console.log(this.payload)
      return this.payload[0]?.transfer?.oneWay;
    }


  close() {
    this._emitRefModal('close');
  }
}
